<div class="product-card">
    <div class="product-image center">
        <img
            src="{{ DEPLOY_URL }}/assets/images/missing.png"
            class="product-image"
            [alt]="product.description"
            width="90"
            appDeferImageLoad
            [imageSrc]="product.image" />
    </div>

    <div class="product-card-content">
        <div class="product-label">
            <div class="product-label-cont">{{ product.label }}</div>
            <div [ngClass]="{ veg: product.veg, 'non-veg': !product.veg }"></div>
        </div>

        <div class="product-description">
            <div class="pull-left prices-wrapper">
                @if (product_prices[product.id]?.price; as origionalPrice) {
                    <div class="price">&#8377;&nbsp;{{ origionalPrice }}</div>
                }
            </div>

            <div class="pull-right">
                <ui-counter-button
                    [customStyles]="{ height: '35px', width: '75px' }"
                    [counter]="quantity"
                    (onCounterChange)="updateCart($event, product.id)">
                </ui-counter-button>
            </div>
        </div>
    </div>
</div>
<div class="clearfix"></div>
